import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface ConcreteKBIconProps {
  size?: number;
  color?: string;
}

const ConcreteKBIcon: React.FC<ConcreteKBIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-concretekb">
    {
      <path d="M16.931 4.58l-9.392 0.047 0.141 9.586h-5.635l1.595 5.16 16.814 0.045 1.502-5.206h-5.212l0.188-9.634z"></path>

    }  </SvgIcon>
);

export default ConcreteKBIcon;
